import React, { useEffect, useState } from "react";
import { Avatar, Box, Typography } from "@mui/material";

import { ActionButton, CardLayout, InputField, SelectField } from "../v3";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AdminService, CRMService } from "../../services";
import { leadActivityValidationRules } from "../../pages/crm/validation";

export const LeadDetails = ({
  setSelectedStatus = () => {},
  setSelectedPriority = () => {},
  leadDetails,
  setLeadDetails = () => {},
  leadData,
  setLeadData = () => {},
}) => {
  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const [errors, setErrors] = useState({});

  const { id } = useParams();

  useEffect(() => {
    fetchData(id);
  }, [id]);

  const fetchData = async (leadId) => {
    try {
      const { data } = await CRMService.getLead(leadId);
      setLeadDetails(data);
      setSelectedStatus(data?.status);
      setSelectedPriority(data?.priority);

      let assignees = [];
      if (Array.isArray(data?.assignees) && data.assignees.length > 0) {
        assignees = data.assignees;
      }
      setSelectedAssignees(assignees);
      setLeadData((prev) => ({
        ...prev,
        assignees: assignees.map((a) => ({
          id: a.id,
          firstName: a.firstName,
          lastName: a.lastName,
        })),
      }));
    } catch (error) {
      console.error("fetchData error:", error);
    }
  };

  const handleAssigneesChange = (selected) => {
    const selectedList = Array.isArray(selected) ? selected : [];
    setSelectedAssignees(selectedList);
    setLeadData((prev) => ({
      ...prev,
      assignees: selectedList.map((assignee) => ({
        id: assignee.id,
        firstName: assignee.firstName,
        lastName: assignee.lastName,
      })),
    }));
  };

  const updateLeadData = (event) => {
    const { name, value } = event.target;
    setLeadData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddActivity = async () => {
    setErrors({});
    const validationErrors = leadActivityValidationRules(leadData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    try {
      await CRMService.updateLeadActivity(id, leadData);
      setLeadData((prev) => ({ ...prev, note: "" }));
      toast("Lead activity updated successfully", { type: "success" });
      fetchData(id);
    } catch (error) {
      console.error("handleAddActivity error:", error);
      toast("Error updating lead activity", { type: "error" });
    }
  };

  // TODO: file uploading feature to be implemented
  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     console.log("Selected file:", file);
  //     setSelectedFile(file.name);
  //   }
  // };

  // const handleDrop = (event) => {
  //   event.preventDefault();
  //   setIsDragging(false);
  //   const file = event.dataTransfer.files[0];
  //   if (file) {
  //     console.log("Dropped file:", file);
  //     setSelectedFile(file.name);
  //   }
  // };

  // const handleDragOver = (event) => {
  //   event.preventDefault();
  //   setIsDragging(true);
  // };

  // const handleDragLeave = () => {
  //   setIsDragging(false);
  // };

  // const handleUploadClick = () => {
  //   if (fileInputRef.current) {
  //     fileInputRef.current.click();
  //   }
  // };
  return (
    <>
      <CardLayout sx={{ padding: "14px" }}>
        <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
          Customer Details
        </Typography>
        <Box
          sx={{
            backgroundColor: "#F6F6F6",
            marginTop: "12px",
            padding: "14px",
            borderRadius: "10px",
          }}
        >
          {/* Customer details*/}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingBottom: "14px",
              borderBottom: "1px solid #E5E5E5",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {/* Profile Photo */}
              <Box
                sx={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  marginRight: "16px",
                }}
              >
                <Avatar
                  src={leadDetails?.imageUrl}
                  alt="Profile"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    backgroundColor: "#F2ECF9",
                  }}
                />
              </Box>

              {/* Details */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                  {leadDetails.contactName}
                </Typography>
                <Typography variant="caption" display="block">
                  {leadDetails.contactPhone}
                </Typography>
              </Box>
            </Box>

            {/* Assignee Dropdown */}
            <Box>
              <SelectField
                label="Assignees"
                value={selectedAssignees}
                multiSelect
                limitTags={1}
                getData={AdminService.getUserList}
                getDataStaticFilters={{ type: "USER", active: true }}
                optionValueFields={["firstName", "lastName"]}
                required
                error={!!errors.assignees}
                helperText={errors.assignees}
                onChange={handleAssigneesChange}
                style={{
                  width: 210,
                  "& .MuiAutocomplete-inputRoot": { flexWrap: "nowrap" },
                  "& .MuiAutocomplete-tag": { maxWidth: 160 },
                  "& .MuiChip-label": { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
                  "& .MuiAutocomplete-input": { minWidth: 0 },
                  "& .MuiOutlinedInput-root": { "&.Mui-focused fieldset": { borderColor: "#583AF3" } },
                  "& .MuiInputLabel-root.Mui-focused": { color: "#583AF3" },
                }}
              />
            </Box>
          </Box>
          {/* note */}
          <InputField
            name="note"
            placeholder="Note"
            value={leadData.note}
            onChange={updateLeadData}
            multiline={true}
            minRows={6}
            fullWidth={true}
            error={!!errors.note}
            helperText={errors.note}
            style={{
              margin: "14px 0px",
              padding: "14px",
              borderRadius: "10px",
              backgroundColor: "#EEEEEE",
              "& .MuiOutlinedInput-root": {
                padding: 0,
                backgroundColor: "transparent",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
          />

          {/* TODO: feature to be implemented */}
          {/* file upload */}
          {/*
                fileInputRef={fileInputRef}
                isDragging={isDragging}
                selectedFile={selectedFile}
                onFileDrop={handleDrop}
                onFileDragOver={handleDragOver}
                onFileDragLeave={handleDragLeave}
                onFileUpload={handleUploadClick}
                onFileChange={handleFileChange}
              /> */}

          <ActionButton
            buttonText="Save"
            onButtonClick={handleAddActivity}
            sx={{
              marginTop: "14px",
              backgroundColor: "#674BF5",
              textTransform: "capitalize",
            }}
          />
        </Box>
      </CardLayout>
    </>
  );
};
